import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import demadingBg from "../../assets/images/demanding-bg.png"
import "./demandingDetail.css"
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faRightLong } from '@fortawesome/free-solid-svg-icons'
const DemandingDetail = () => {
    return (
        <section className='demanding-detail'>
            <Container fluid>
                <Row>
                    <Col lg={4}>
                        <div className='demanding-sec position-relative h-100'>
                            <div className='bg-img h-100'>
                                <Image src={demadingBg} alt='demanding bg' className='h-100' fluid />
                            </div>
                            <div className='content-wrapper'>
                                <span className='title'>Most Demanding</span>
                                <p className='mb-0'>Our most sought-after product is our meticulously hand-embroidered elegance showcased in customized lehengas.</p>
                                <Link href="#" className='arrow-link text-white'>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </Link>
                            </div>
                        </div>
                    </Col>
                    <Col lg={8}>
                        <div className='who-shafaq-waqas text-white text-center'>
                            <div className='content-wrapper mb-5'>
                                <h3 className='h3 mb-4'>Who’s Shafaq Waqas?</h3>
                                <p className='mb-4'>Shafaqwaqas.com is the founder of Painting Corner by Shafaq, the largest hand-painted platform providing custom products worldwide. Our designers create unique hand-painted designs on various fabrics, meeting customer requirements. Specializing in ladies’, bridal, and baby wares, tailored to specific sizes.</p>
                                <p>
                                    We specialize in customized stitching of various dresses including shalwar kameez, lehenga choli, shirt trousers, Maxi, Sharara, Gharara, cutwork embroidered dupattas, as well as customized embellishments ranging from heavy-loaded to light embellishments, and much more. Cash on delivery (COD) is also available, reflecting our commitment to customer convenience.
                                </p>
                            </div>
                            <button className='yellow-btn'>
                            Contact us
                            </button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default DemandingDetail